import { render, staticRenderFns } from "./SidebarPlacement.vue?vue&type=template&id=545be100&"
import script from "./SidebarPlacement.vue?vue&type=script&lang=js&"
export * from "./SidebarPlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports